import { Plan } from '../../../types/plan';
import { formatAmountUI } from '../../../utils/price/price.utils';
import {
  ProductBestValueContainer,
  ProductBestValueLabel,
  ProductContainer,
  ProductContainerLeft,
  ProductContainerRight,
  ProductDescription,
  ProductLabelText,
  ProductLabelWrapper,
  ProductPrice,
  ProductPriceDescription,
  ProductPriceWithoutBargainText,
  ProductTotalPrice,
  ProductTotalPriceWrapper,
} from './ProductV2.style';

interface ProductV1Props {
  product: Plan;
  chosenPlanPosition?: string | null;
  onClick: () => void;
}

export const ProductV2 = ({ product, onClick, chosenPlanPosition }: ProductV1Props) => {
  const { amount, metadata } = product;
  const isPicked = metadata.position === chosenPlanPosition;
  const isMonthly = metadata.numberOfMonths && metadata.numberOfMonths === '1';
  const showTotalPrice = metadata.numberOfMonths && metadata.numberOfMonths !== '1';
  const totalPriceUI = formatAmountUI(amount);

  return (
    <ProductContainer enabled={isPicked} onClick={onClick}>
      {metadata.isBestValue === 'true' && (
        <ProductBestValueContainer>
          <ProductBestValueLabel>Best value</ProductBestValueLabel>
        </ProductBestValueContainer>
      )}
      <ProductContainerLeft>
        <ProductDescription>{metadata.descriptionV2 ?? metadata.description}</ProductDescription>

        <ProductTotalPriceWrapper>
          <ProductTotalPrice>
            {isMonthly && <>Total of ${totalPriceUI}</>}
            {!isMonthly && (
              <>
                ${totalPriceUI} {metadata.billingPeriodLabel}
              </>
            )}
          </ProductTotalPrice>
          {!!metadata.priceWithoutBargain && (
            <ProductPriceWithoutBargainText>${metadata.priceWithoutBargain}</ProductPriceWithoutBargainText>
          )}
        </ProductTotalPriceWrapper>
        {!showTotalPrice && metadata.priceDescription && (
          <ProductPriceDescription>{metadata.priceDescription}</ProductPriceDescription>
        )}
      </ProductContainerLeft>
      <ProductContainerRight>
        {metadata.monthlyPrice && <ProductPrice>${metadata.monthlyPrice}/mo</ProductPrice>}
        {!metadata.monthlyPrice && <ProductPrice>${totalPriceUI}</ProductPrice>}
        {!!metadata.label && (
          <ProductLabelWrapper isPicked={isPicked}>
            <ProductLabelText isPicked={isPicked}>{metadata.label}</ProductLabelText>
          </ProductLabelWrapper>
        )}
      </ProductContainerRight>
    </ProductContainer>
  );
};
